import React from 'react';
import { TextButton } from '@Shared.Angular/flowingly.components/buttons/TextButton';

export interface IVersionHistoryItem {
  title?: string;
  subtitle?: string;
  time?: string;
  badge?: () => React.ReactNode;
}
type VersionHistoryItemProps = {
  versionHistoryItem: IVersionHistoryItem;
  onClick?: () => void;
  onViewClick?: () => void;
  onRestoreClick?: () => void;
};

export const VersionHistoryItem = ({
  versionHistoryItem,
  onClick,
  onViewClick,
  onRestoreClick
}: VersionHistoryItemProps) => {
  const { title, subtitle, time, badge } = versionHistoryItem;

  const handleClick = () => {
    if (onClick) {
      onClick();
    }
  };

  return (
    <div
      className={`version-history-item ${onClick ? 'clickable' : ''}`}
      onClick={handleClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      data-testid="version-history-item"
    >
      <div className="item-leading">{badge && badge()}</div>

      <div className="item-content">
        <div className="item-title">{title}</div>
        {subtitle && <div className="item-subtitle">{subtitle}</div>}
      </div>

      <div className="item-right-column">
        {time && <div className="item-time">{time}</div>}

        <div className="item-actions" onClick={(e) => e.stopPropagation()}>
          {onViewClick && (
            <TextButton text="View" type="secondary" onClick={onViewClick} />
          )}
          {onRestoreClick && (
            <TextButton
              text="Restore"
              type="primary"
              onClick={onRestoreClick}
            />
          )}
        </div>
      </div>
    </div>
  );
};
